<template>
  <div>
    <div data-v-60ee706e="" class="loginwindow transitionBody">
      <div data-v-60ee706e="" class="lginner"><img data-v-60ee706e=""
              src=""
              alt="" class="gbline" @click="back">
          <div data-v-60ee706e="" class="loglines"></div>
          <div data-v-60ee706e="" class="LoginSquare">
              <div data-v-60ee706e="" class="inputline"><input v-model="name" data-v-60ee706e="" type="text" maxlength="16"
                      placeholder="请输入手机号或用户名">
                  <div data-v-60ee706e=""></div>
              </div>
              <div data-v-60ee706e="" class="inputline">
                  <div data-v-60ee706e=""></div><input v-model="password" data-v-60ee706e="" maxlength="16" placeholder="请输入密码"
                  :type="show1?'text':'password'">
                      
                      <img
          @click="show1=!show1"
          v-if="!show1"
            data-v-65d98e59=""
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAgCAMAAACVQ462AAAAjVBMVEUAAAAeI0guLkkdJUgdJUgdJUgdJEgdJUccJUgfI0kcJUgdJUgdJUgYJEccJUgdJEgcJEcdJEccJEgdJEkcI0cdJUgcJUccJEgcJEgdJUccJEkbJEgdJUcdJUgcJUgdJEgdJUgdJUgdJUgdJUgcJUcdJEccJUcdJUgdJUghIU4dJUgcJUgdJkcfJUsdJUjDjfUdAAAALnRSTlMAGAX65WRVyLEQ4HL3C+vSwKhcMSD0t35rRD8479vXy8OjnIN3SiysiQeWUTwp1k+5hAAAAZdJREFUSMedlNmWgjAMQMPSgoCIgMqmgOI2av7/8+agbSnLDOB9UQK3aUMCqCdrY5UXmM3dL/OCANywxknn+qH1Fm1w8Y21mOer+cfTIcMPJszih2kb8Q9vc/yIWyUsLWRU032fO7oC8NSQcZrqE6Gc60sbOcf7JP+EnZSlCBjhuK5sETuFV5vQxlbHju826ZY8uPRQcKD/6bGBglxqneUWG/a2MmwvSI4NRav1diijeXbQPcqLmA7KVPLSJvZwVtdbRM9xHFOyOxYZ9liLEgQWfsWBzTBx8Es2PmtrETCmaCsp4QMA9GZLLzgbozqFYC+3UtgpSnLV/rY1M24XPQNI+b1IvJNIH9b1pkEqniWEgH2RUqmtMhzElXojYUkUgFX9u5WbjzBhm1BKCKVJwQK+PFPv9vcAIPQ0vQKZlRh2BuXTAxLqzkVzsOkTPhPNs7woAUxhzZ62+6NynOIrrMDOYjA2SpNtZFcdRs77FHUZJRUVH3wzl8kL+O0wmbyAesAaT22H7wbb1zih6VrrRz9Or7q77jfOLwi5kdPVEhAyAAAAAElFTkSuQmCC"
            class="eye"
          />
          <img v-else @click="show1=!show1" data-v-65d98e59="" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAoCAMAAAB5EAzbAAAAn1BMVEUAAAAdJUgqKkkdJUcdJUgdJEcYKUQdJUgcJUgeJEgdIUceIE0cJUgcJUgdJUgdJUccJEgdJUgdJUgcJUgdJEgdJUgcJUgdJEgcJUgdJUgdJEgbI0gdJUkcJUceJUkfI0kdHU0dJUgdJEgcJUgdJUgdJEccJEgcJUkcIkYcJUgcJUccJUgcJEkdJUgcJUgdJEgdJkkfJ0YgKEgcJUgdJUiVJwGxAAAANHRSTlMA+Abv3EkM69AzHhC+drCphmbk4MO6a5OKcU9APi0oGAjyyqylm1s4JLWhj4Bf19TMISBSdyDvIwAAAe9JREFUSMellOmyojAQhU9YBRQRccf1uutdp9//2cZhklRCUJT7/aHqpOnkdHc1DMLYT9/2hmy9x+k6DlGL9UH/2Kx02WsVcgu1BPSfni4PuRw8l8C8y+HyAnXI0JkqukZaA+OxsSoOpLF6PJsHKxVfcMlf4QlGPHpsSkn1lfkcKkcebXtCidZUwEKozGdFhGsTDZZQiMuGJ1zoQuEnu1maAZ5fmHMrSu5cdt0bu0ufCwclaFqUKrVwqLD3STpmD62LnItAHGchNzzM6A6bCbf6vRFSBK/4ShvBmdEDWPfAn89dAmiTJAlOVEs7H5FkBGDhUGOcsDD9Rg3ZemL87/j2nVaWfTn96mPWgyQo27DjibuwIFjmvV055EOb33f1KE0CVHDsaDmG9/4fTHGXXC3XBJKeMm0zPGSudL0jxD9SYh3UsrdJwKt4YLKtczxBuCGBW1Q4lTMWmUs+DGGKsWzWUR3lk7Gv3AG72TrNjAxd4nxZmMj7Leh4suRbI/VWHF0hlsVnVL4mU1prvEG828eau/lBiYQUjO5Eff4fzlQwNSKYNtoWSgRrvrq9LSPWds12k4YZsOwM0v61SByhgjFpdPAqO9IY41WS375gSho5XmXlk0IfrzMkhT0acFa3dyOuTG6JhhzHLdtuJd94wF9aYcKHBwtsvgAAAABJRU5ErkJggg==" class="eye">
              </div>
              <div data-v-60ee706e="" id="captcha" style="position: relative; top: 10px;"></div>
              <div data-v-60ee706e="" class="inputline" style="display: none;"><input data-v-60ee706e="" type="text"
                      placeholder="请输入验证码"><img data-v-60ee706e=""
                      src="https://api.dine.run/src/index/get_img_code?username=" class="yzm"></div>
              <div data-v-60ee706e="" class="oplines">
                  <div data-v-60ee706e="" class="ltbox" @click="auto=!auto">
                    <img data-v-60ee706e=""
                    v-if="!auto"
                          src="data:image/png;base64,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"
                          alt="">
                          <img v-else data-v-60ee706e="" src="data:image/png;base64,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" alt="">
                          自动登录 </div>
                  <div data-v-60ee706e="" class="rtbox" @click="login2">游戏试玩</div>
                  <div data-v-60ee706e="">忘记密码</div>
              </div>
              <div data-v-60ee706e="" class="confirm"><span @click="login" data-v-60ee706e="" id="login" class="sumbtns" :class="{sbac:isOk}">登录账号</span>
              </div>
              <div data-v-60ee706e="" class="botline">
                  <div data-v-60ee706e="">联系客服</div>
                  <div data-v-60ee706e="" @click="go('/reg2')">注册账号</div>
              </div>
          </div>
      </div>
  </div>
  </div>
</template>
<script>
export default {
  name: 'login',
  data() {
    return {
      show1:false,
      auto:false,
      registerInfo: {},
      loginInfo: {},
      imgLis: ['2PYL', '6AQ5', '8PHD', '21I7', '69HM', 'ACWA', 'DUZ7', 'IY98', 'K647', 'M52T', 'NY52', 'NZFA', 'SN76', 'SP4D', 'VAEO', 'YFQM', 'ZZU5', '7GQT', 'LFW3', 'NU2T', 'UAE3'],
      index: 0,
      infoType: 0, //0 是登陆 1是注册
      psw1: true,
      psw2: true,
      psw3: true,
      pid: '',
      name:'',
      password:'',
      isOk:false
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.type) {
      that.infoType = query.type;
    }
    if (query.pid) {
      that.pid = query.pid;
    }
    that.changIndex();
  },
  watch:{
    name(){
      this.get_test()
    },
    password(){
      this.get_test()
    }
  },
  methods: {
    get_test(){
      if(this.name&&this.password){
        this.isOk=true
      }else{
        this.isOk=false
      }
    },
    back(){
      window.history.go(-1)
    },
    go(s){
      this.$router.push(s)
    },
    changPsw(name) {
      this[name] = !this[name];
    },
    changInfoType(type) {
      if(type==1){
        this.$router.push('reg')
        return
      }
      let that = this;
      if (that.infoType == type) {
        return;
      }
      that.infoType = type;
      that.changIndex();
      that.loginInfo = {};
      that.registerInfo = {};
      this.psw1 = true;
      this.psw2 = true;
      this.psw3 = true;
    },
    changIndex() {
      this.index = parseInt(20 * Math.random());
    },
    register() {
      let that = this;

      let info = that.registerInfo;
      console.log(info);
      if (!info.name || info.name.length < 6) {
        that.$parent.showTost(0, ' 用户名长度6~16位，以字母或数字组合！');
        return;
      }
      if (!info.password || info.password.length < 6) {
        that.$parent.showTost(0, '请输入正确的密码长度，最少6位！');
        return;
      }
      // if (!info.confirmPass || info.confirmPass != info.password) {
      //   that.$parent.showTost(0, '两次密码不一致！');
      //   return;
      // }
      // if (!info.realname || info.realname.length < 2) {
      //   that.$parent.showTost(0, '请输入您的真实姓名!');
      //   return;
      // }

      // if (!info.paypassword || info.paypassword.length < 6) {
      //   that.$parent.showTost(0, '请输入正确的支付密码长度，最少6位！');
      //   return;
      // }
      // let code = that.registerInfo.code;
      // if (!code) {
      //   that.$parent.showTost(0, '请输入验证码！');

      //   return;
      // }
      // if (code.toUpperCase() != that.imgLis[that.index]) {
      //   that.$parent.showTost(0, '验证码错误！');
      //   that.registerInfo.code = null;
      //   that.changIndex();
      //   return;
      // }
      that.$parent.showLoading();
      if (that.pid) {
        info.pid = that.pid;
      }
      console.log(info);
      that.$apiFun.register(info).then(res => {
        that.$parent.showTost(1, res.message);
        if (res.code == 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          that.$parent.goNav('/');
        }
        that.$parent.hideLoading();
      });
    },
    login() {
      let that = this;
      let info = {
        name:this.name,
        password:this.password
      };
      if (!info.name || !info.password) {
        // that.$parent.showTost(0, '请输入您的账号和密码！');
        return;
      }
      // let code = that.loginInfo.code;
      // if (!code) {
      //   that.$parent.showTost(0, '请输入验证码！');

      //   return;
      // }
      // if (code.toUpperCase() != that.imgLis[that.index]) {
      //   that.$parent.showTost(0, '验证码错误！');
      //   that.loginInfo.code = null;
      //   that.changIndex();
      //   return;
      // }

      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
          that.$parent.hideLoading();
        }
        if (res.code === 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          that.$parent.goNav('/');
        }
        that.$parent.hideLoading();
      });
    },
    login2(){
      let that = this;
      let info = {
        name:"游客试玩123456",
        password:123456
      };
      that.$parent.showLoading();
      that.$apiFun.login(info).then(res => {
        if (res.code === 200) {
          sessionStorage.setItem('token', res.data.api_token);
          that.$store.commit('changToken');
          that.$parent.getUserInfo();
          that.$parent.openDaoTime();

          that.$parent.goNav('/');
        }
        that.$parent.hideLoading();
      }).catch(err=>{
        that.$parent.hideLoading();
      })
    }
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
// .login {
//   background: url(/static/img/bgimg.c7a960a1.jpg) no-repeat;
//   width: 100%;
//   height: 100%;
//   position: fixed;
//   background-size: 100% 100%;
// }

.loginwindow[data-v-60ee706e] {
  width:100%;
  height:100vh;
  background-color:#fff;
  background-image:url(https://wswds3.shranshen.com/h5_static/wd/img/loginBg.a282cc08.png);
  background-repeat:no-repeat;
  background-size:100% auto
}
.loginwindow .loglines[data-v-60ee706e] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center;
  width:100%;
  height:2.13333rem;
  margin-top:1.73333rem;
  margin-bottom:1.12rem
}
.loginwindow .loglines img[data-v-60ee706e] {
  width:4rem
}
.loginwindow .lginner[data-v-60ee706e] {
  float:left;
  width:100%;
  box-sizing:border-box;
  width: 9.2rem;
  height: 9.2rem;
    z-index: 200;
    border: .02667rem solid #fff;
    background-color: #f0f4fa;
    border-radius: 0.53333rem;
    margin: 0 auto;
    margin-top: 7.33333rem;
    left: .4rem;
    right: .4rem;
    display: webkit-box;
    display: webkit-flex;
    display: ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding-top: 1.12rem;
    padding-bottom: 1.12rem;
    left: 50px;
    transform: translateX(18px);
    margin-top: 293px;
  padding:0 1.06667rem
  
}
.loginwindow .lginner .gbline[data-v-60ee706e] {
  position:fixed;
  right:.26667rem;
  top:.26667rem;
  
  width:1.06667rem
}
.loginwindow .LoginSquare .inputline[data-v-60ee706e] {
  float:left;
  width:100%;
  height:1.2rem;
  background-color:#fff;
  border-radius:.26667rem;
  box-sizing:border-box;
  margin-top:.26667rem;
  position:relative;
  display: flex;
  align-items: center;
}
.loginwindow .LoginSquare .inputline input[data-v-60ee706e] {
  width:6.66667rem;
  // height:100%;
  padding-left:.4rem;
  color:#1d2548;
  text-align:left;
  line-height:1.12rem;
  font-size:.37333rem;
  border:none;
  outline:none;
  z-index:2;
  border-radius:.26667rem;
  background-color:#fff
}
.loginwindow .LoginSquare .inputline div[data-v-60ee706e] {
  width:50%;
  height:1.2rem;
  float:left;
  color:red;
  position:absolute;
  z-index:1;
  right:0;
  border-radius:.26667rem
}
.loginwindow .LoginSquare .inputline .eye{
  width:.42667rem;
  height:.21333rem;
  margin-right:.4rem;
  z-index:3;
  position: relative;
  z-index: 10;
}
.loginwindow .LoginSquare .inputline .yzm[data-v-60ee706e] {
  width:1.89333rem;
  height:.66667rem;
  border:.02667rem solid #e3e4ea;
  float:right;
  margin-top:.21333rem;
  margin-right:.4rem;
  right:0;
  position:absolute;
  z-index:3
}
.loginwindow .LoginSquare .confirm[data-v-60ee706e] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:center;
  -webkit-justify-content:center;
  -ms-flex-pack:center;
  justify-content:center
}
.loginwindow .LoginSquare .confirm .sumbtns[data-v-60ee706e] {
  height:1.2rem;
  color:#fff;
  width:5.33333rem;
  background-color:#a134f1;
  border-radius:.21333rem;
  margin-top:.8rem;
  font-size:.45333rem;
  font-weight:700;
  opacity:.7;
  text-align: center;
  line-height: 1.2rem;
}
.loginwindow .LoginSquare .confirm .sbac[data-v-60ee706e] {
  opacity:1
}
.loginwindow .LoginSquare .botline[data-v-60ee706e] {
  float:left;
  width:100%;
  height:.37333rem;
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  margin-top:.53333rem
}
.loginwindow .LoginSquare .botline div[data-v-60ee706e] {
  flex:1;
  color:#0b1028;
  font-size:.37333rem;
  text-align: center;
}
.loginwindow .LoginSquare .botline div[data-v-60ee706e]:first-child {
  margin-left:.8rem
}
.loginwindow .LoginSquare .botline div[data-v-60ee706e]:nth-child(2) {
  margin-right:.8rem
}
.loginwindow .LoginSquare .oplines[data-v-60ee706e] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-pack:justify;
  -webkit-justify-content:space-between;
  -ms-flex-pack:justify;
  justify-content:space-between;
  width:100%;
  padding-top:.77333rem;
  color:#1d2548;
  font-size:.4rem;
  font-family:PingFang SC;
  font-weight:500
}
.loginwindow .LoginSquare .oplines>div .van-checkbox__icon[data-v-60ee706e] {
  font-size:.34667rem;
  height:.34667rem;
  line-height:.34667rem
}
.loginwindow .LoginSquare .oplines>div .van-icon[data-v-60ee706e] {
  width:.34667rem;
  height:.34667rem;
  border-radius:.08rem
}
.loginwindow .LoginSquare .oplines>div .van-checkbox__label[data-v-60ee706e] {
  height:.34667rem;
  line-height:.34667rem
}
.loginwindow .LoginSquare .oplines>div .van-checkbox__icon--checked .van-icon[data-v-60ee706e] {
  background-color:#1989fa
}
.loginwindow .LoginSquare .oplines .ltbox[data-v-60ee706e] {
  display:-webkit-box;
  display:-webkit-flex;
  display:-ms-flexbox;
  display:flex;
  -webkit-box-align:center;
  -webkit-align-items:center;
  -ms-flex-align:center;
  align-items:center
}
.loginwindow .LoginSquare .oplines .ltbox>img[data-v-60ee706e] {
  margin-right:.08rem;
  width:.85333rem;
  height:.48rem
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue